export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_hi.d46c1048011a0893.json"